"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftPeriod = void 0;
var GiftPeriod;
(function (GiftPeriod) {
    GiftPeriod["Month"] = "month";
    GiftPeriod["ThreeMonth"] = "threeMonth";
    GiftPeriod["Year"] = "year";
    GiftPeriod["Lifetime"] = "lifetime";
})(GiftPeriod = exports.GiftPeriod || (exports.GiftPeriod = {}));
